__turbopack_context__.v({
  "acheivername": "acheiver-module__wuCyIG__acheivername",
  "acheiverrank": "acheiver-module__wuCyIG__acheiverrank",
  "avatar": "acheiver-module__wuCyIG__avatar",
  "imageBox": "acheiver-module__wuCyIG__imageBox",
  "imageWrapper": "acheiver-module__wuCyIG__imageWrapper",
  "redStrip": "acheiver-module__wuCyIG__redStrip",
  "scrolldiv": "acheiver-module__wuCyIG__scrolldiv",
  "scrollparent": "acheiver-module__wuCyIG__scrollparent",
  "sectionredtitle": "acheiver-module__wuCyIG__sectionredtitle",
  "viewbutton": "acheiver-module__wuCyIG__viewbutton",
  "viewbuttonalink": "acheiver-module__wuCyIG__viewbuttonalink",
});
